import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import RightsCheck from "../General/RightsCheck";

const PrintGeneralLedger = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(true);
  const [listOfLedger, setLedger] = useState([]);
  const [accountTitle, setAccountTitle] = useState("");
  const [periodLabel, setPeriodLabel] = useState("");
  const [totalDebit, setTotalDebit] = useState("");
  const [totalCredit, setTotalCredit] = useState("");
  const [finalBalance, setFinalBalance] = useState("");

  useEffect(() => {
    document.title = "Print General Ledger";
    document.body.classList.add("print-body");
    return () => {
      document.body.classList.remove("print-body");
    };
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const fYear = parseInt(params.get("FYear") || "0", 10) || 0;
    const accountCode = params.get("AccountCode") || "";
    let startDate = params.get("StartDate") || "";
    let endDate = params.get("EndDate") || "";

    if (!fYear || !accountCode) {
      setLoading(false);
      return;
    }

    if (!startDate || !endDate) {
      const fyStart = moment(`${fYear}-04-01`);
      const fyEnd = moment(`${fYear + 1}-03-31`);
      const today = moment();
      const defaultEnd = today.isBetween(fyStart, fyEnd, "day", "[]") ? today : fyEnd;
      if (!startDate) {
        startDate = fyStart.format(config.date_format_input);
      }
      if (!endDate) {
        endDate = defaultEnd.format(config.date_format_input);
      }
    }

    setPeriodLabel(
      `${moment(startDate).format("DD/MM/YYYY")} to ${moment(endDate).format("DD/MM/YYYY")}`
    );

    axios({
      method: "post",
      url: config.base_url + "Accounts/GetGeneralLedger",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: fYear,
        AccountCode: accountCode,
        StartDate: startDate,
        EndDate: endDate,
      },
    })
      .then((response) => {
        if (response.data?.status_code !== 0 && Array.isArray(response.data.ListofRecords)) {
          setLedger(response.data.ListofRecords);
          setTotalDebit(response.data.TotalDebit ?? "");
          setTotalCredit(response.data.TotalCredit ?? "");
          setFinalBalance(response.data.FinalBalance ?? "");
          setAccountTitle(
            response.data.AccountCode && response.data.AccountDesc
              ? `${response.data.AccountCode} — ${response.data.AccountDesc}`
              : accountCode
          );
        } else {
          setLedger([]);
          setAccountTitle(accountCode);
        }
        setLoading(false);
      })
      .catch(() => {
        setLedger([]);
        setAccountTitle(accountCode);
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const formatBalance = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) {
      return value;
    }
    return num < 0 ? `(${Math.abs(num)})` : value;
  };

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>
            {item.Selected_Voucher?.Voucher_date
              ? moment(item.Selected_Voucher.Voucher_date).format("DD-MMM-YYYY")
              : ""}
          </td>
          <td>{item.Selected_Voucher?.Voucher_number}</td>
          <td>{item.Narration}</td>
          <td className="text-end">{item.Dr_Amt}</td>
          <td className="text-end">{item.Cr_Amt}</td>
          <td className="text-end">{formatBalance(item.Balance)}</td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan={6}>
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <RightsCheck />
      <Page orientation="portrait" size="a4">
        <PrintHeader title="General Ledger" />
        <div className="mb-2" style={{ fontSize: "10pt", lineHeight: 1.4 }}>
          {accountTitle ? <div><strong>Account:</strong> {accountTitle}</div> : null}
          {periodLabel ? <div className="text-end"><strong>Period:</strong> {periodLabel}</div> : null}
        </div>
        <table className="table table-sm table-bordered table-print w-100">
          <thead>
            <tr>
              <th>Dated</th>
              <th>Voucher No</th>
              <th>Narration</th>
              <th className="text-end">Dr.</th>
              <th className="text-end">Cr.</th>
              <th className="text-end">Balance</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan={6}>
                  <Spinner animation="border" role="status" />
                </td>
              </tr>
            ) : (
              renderLedger()
            )}
          </tbody>
          {!loading && listOfLedger.length > 0 && (
            <tfoot>
              <tr>
                <th colSpan={3} className="text-end">
                  Totals
                </th>
                <th className="text-end">{totalDebit}</th>
                <th className="text-end">{totalCredit}</th>
                <th className="text-end">{formatBalance(finalBalance)}</th>
              </tr>
            </tfoot>
          )}
        </table>
      </Page>
    </>
  );
};

export default PrintGeneralLedger;
